/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export default {
    getInvoiceRisk(state) {
        return state.InvoiceRisk;
    },
    getInvoiceRiskTotal(state) {
        return state.InvoiceRiskTotal;
    },
    IsLoadingTotalInvoiceRiskRecords(state) {
        return state.IsLoadingTotalInvoiceRiskRecords;
    },
    getInvoiceSupplierActives(state) {
        return state.InvoiceSupplierActives;
    },
    getInvoiceSupplierActiveTotal(state) {
        return state.InvoiceSupplierActiveTotal;
    },
    IsLoadingTotalInvoiceRiskRecords(state) {
        return state.IsLoadingInvoiceSupplierActiveTotal;
    },
    getInvoiceRelated(state) {
        return state.InvoiceRelateds;
    },
    getInvoiceRelatedTotal(state) {
        return state.InvoiceRelatedTotal;
    },
    getCostTypeSummaryReportTotal(state) {
        return state.CostTypeSummaryReportTotal;
    },
    getReportExceedCostTotal(state) {
        return state.ReportExceedCostTotal;
    },
    getDataCostTypeSummaryReport(state) {
        return state.DataCostTypeSummaryReport;
    },
    getDataReportExceedCost(state) {
        return state.DataReportExceedCost;
    },
    getReportTypeAndCostTotal(state) {
        return state.TypeAndCostTotal;
    },
    getDataTypeAndCost(state) {
        return state.DataTypeAndCost;
    },
    getDataTypeAndCostDataPage(state) {
        return state.DataTypeAndCostDataPage;
    },
    getInvoiceByNormTotal(state) {
        return state.InvoiceByNormTotal;
    },
    getInvoiceByNorm(state) {
        return state.InvoiceByNorm;
    },
    IsLoadingTotalInvoiceRelatedRecords(state) {
        return state.IsLoadingInvoiceRelatedTotal;
    },
    IsLoadingTotalCostTypeSummaryecords(state) {
        return state.IsLoadingCostTypeSummaryReportTotal;
    },
    IsLoadingTotalReportExceedCostRecords(state) {
        return state.IsLoadingReportExceedCostTotal;
    },
    IsLoadingTotalTypeAndCostRecords(state) {
        return state.IsLoadingTypeAndCostTotal;
    },
    getInvoiceStick(state) {
        return state.InvoiceStick;
    },
    getInvoiceStickTotal(state) {
        return state.InvoiceStickTotal;
    },
    IsLoadingTotalInvoiceStickRecords(state) {
        return state.IsLoadingInvoiceStickTotal;
    },
    getInvoiceListForStickTotal(state) {
        return state.InvoiceListForStickTotal;
    },
    /**
     * Lấy tổng số hóa đơn vượt ngưỡng 5 triệu
     * @param {Object} state - Vuex state
     * @returns {Number} Tổng số hóa đơn vượt ngưỡng
     * @author dqduy 11. 2025
     */
    getInvoiceExceedTotal(state) {
        return state.InvoicesExceedTotal
    },

    /**
     * Lấy danh sách hóa đơn vượt ngưỡng 5 triệu
     * @param {Object} state - Vuex state
     * @returns {Array} Danh sách hóa đơn vượt ngưỡng
     * @author dqduy 11.2025
     */
    lstInvoicesExceed(state) {
        return state.ListInvoicesExceed
    },
};